import { defineMessages } from "react-intl";

export const rippleActionMessages = defineMessages({
  readTheDocs: {
    defaultMessage: "Read the docs",
    id: "Cm2/+V",
  },
  readTheBlogPost: {
    defaultMessage: "Read the blog post",
    id: "cti4iA",
  },
  showMe: {
    defaultMessage: "Show me",
    id: "1ACBFw",
    description: "Ripple tooltip confirmation button",
  },
});
